<template>
  <div class="other-sync-count-container" v-rect-loading="loading">
    <CounterList
      class="other"
      :titleI18nKey="`${i18nPrefix}.label.otherSync`"
      :data="otherCountData"
    >
    </CounterList>
  </div>
</template>

<script>
import CounterList from './counterList.vue'
import mixin from './countMixin'

export default {
  mixins: [mixin],
  components: {
    CounterList
  },
  data () {
    return {
      i18nPrefix: 'admin.apScheduler',
      type: 'other',
      loading: false,
      countData: []
    }
  },
  computed: {
    otherCountData () {
      const i18nPrefix = this.i18nPrefix
      return [
        { labelI18nKey: `${i18nPrefix}.label.task.total`, value: this.countData.total_count || 0 },
        { labelI18nKey: `${i18nPrefix}.label.task.open`, value: this.countData.open_count || 0 },
        { labelI18nKey: `${i18nPrefix}.label.task.close`, value: this.countData.close_count || 0 }
      ]
    }
  },
  created () {
    this.initData()
  },
  methods: {
    async initData () {
      this.loading = true
      try {
        this.countData = await this.getCountDataByTypeAndDay(0, this.type)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
